import { render, staticRenderFns } from "./TagMedia.vue?vue&type=template&id=3d9199e7"
import script from "./TagMedia.vue?vue&type=script&lang=js"
export * from "./TagMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports